import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { ReportBoxValueDataTypeEnum } from '@pages/reports/types/report-box-value-data-type.enum';
import { formatCustomPercentage, formatNumberWithSuffix } from '@utils/format-functions';
import { IconSanitizerService } from 'ngx-lib';

@Component({
    selector: 'app-box',
    standalone: true,
    templateUrl: './box.component.html',
    styleUrls: ['./box.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class BoxComponent {
    private readonly iconSanitizer = inject(IconSanitizerService);

    readonly numericValue = input<number>(0);
    readonly titleValue = input<string>('');
    readonly formatType = input<ReportBoxValueDataTypeEnum>(ReportBoxValueDataTypeEnum.String);

    readonly icon = computed(() => {
        if (this.formatType() === ReportBoxValueDataTypeEnum.Currency) return this.iconSanitizer.getIcon('dollar');
        return this.iconSanitizer.getIcon('bubbles');
    });

    readonly formatValue = computed(() => {
        if (this.formatType() === ReportBoxValueDataTypeEnum.Percentage)
            return formatCustomPercentage(this.numericValue());
        if (this.formatType() === ReportBoxValueDataTypeEnum.Currency)
            return formatNumberWithSuffix(this.numericValue());
        return this.numericValue();
    });

    public readonly formatTypes = ReportBoxValueDataTypeEnum;
}
